//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { analytics } from "/src/main.js";
import { db } from "../main.js";
export default {
  data() {
    return {
      notes: "Ex: Remember to use center and core while going forward",
      notesSaved: null,
    };
  },
  computed: {
    currentLessonKey() {
      return this.$store.state.currentLessonKey;
    },
  },
  watch: {
    currentLessonKey() {
      this.getNotes();
    },
  },
  methods: {
    saveNotes() {
      var user = this.$store.state.user.uid;
      var lessonKey = this.$store.state.currentLessonKey;
      if (this.notesSaved != this.notes) {
        this.notesSaved = this.notes;
        db.ref(`users/${user}/notes/${lessonKey}/`).set({ text: this.notes });
      }
      analytics.logEvent("saveNote");
    },
    getNotes() {
      var user = this.$store.state.user.uid;
      var lessonKey = this.$store.state.currentLessonKey;
      db.ref(`users/${user}/notes/${lessonKey}/text/`)
        .get()
        .then((snapshot) => {
          if (snapshot.exists()) {
            this.notes = snapshot.val();
            this.notesSaved = snapshot.val();
          } else {
            this.notes = null;
            this.notesSaved = null;
          }
        });
    },
  },
  created() {
    if (this.$store.state.user) {
      this.getNotes();
    }
  },
};
